import PlaceParent from '../pages/place/components/PlaceParent'

import PlaceAccommodation from '../pages/place/place-accommodation'

import PlaceRules from '../pages/place/place-rules'
import PlaceRulesBaseCreateEdit from '../pages/place/place-rules/components/base-rule/CreateEdit'
import PlaceRulesSeasonalCreateEdit from '../pages/place/place-rules/components/seasonal-rule/CreateEdit'
import PlaceRulesManage from '../pages/place/place-rules/components/manage-rule/Manage'

import PlaceExtras from '../pages/place/place-extras'
import PlaceExtrasCreateEdit from '../pages/place/place-extras/components/CreateEdit'
import PlaceExtrasManage from '../pages/place/place-extras/components/Manage'

import PlaceRates from '../pages/place/place-rates'
import PlaceRatesCreateEdit from '../pages/place/place-rates/components/CreateEdit'
import PlaceRatesManage from '../pages/place/place-rates/components/Manage'

const memberAreaBreadcrumb = {
  text: "*Sawday's Member Area*",
  titleI18NKey: 'global-terms.member-area',
  disabled: false,
  href: `${process.env.VUE_APP_EZ_HOST}/owner-area`,
}

const PlaceRoute = {
  path: '/place/:placeId',
  component: PlaceParent,
  meta: {
    title: '*Manage Place*',
    titleI18NKey: 'global-terms.manage-place',
    breadcrumbs: [memberAreaBreadcrumb],
  },
}

// push self onto breadcrumbs
PlaceRoute.meta.breadcrumbs.push({
  text: PlaceRoute.meta.title,
  disabled: true,
})

const AccommodationRoute = {
  path: 'accommodation',
  name: 'place-accommodation',
  meta: {
    title: null,
    titleI18NKey: 'page-accommodation.title',
    introI18NKey: 'page-accommodation.intro',
    breadcrumbs: [memberAreaBreadcrumb],
  },
  component: PlaceAccommodation,
}

// push self onto breadcrumbs
AccommodationRoute.meta.breadcrumbs.push({
  titleI18NKey: (AccommodationRoute.meta.titleI18NKey) ? AccommodationRoute.meta.titleI18NKey : false,
  text: AccommodationRoute.meta.title,
  disabled: true,
})

const RulesRoute = {
  path: 'rules',
  component: PlaceRules,
  children: [
    {
      path: '',
      name: 'place-rules-manage',
      component: PlaceRulesManage,
      meta: {
        titleI18NKey: 'page-rules.manage.title',
        introI18NKey: 'page-rules.manage.intro',
        breadcrumbs: [memberAreaBreadcrumb],
      },
    },
    {
      path: 'base/create',
      name: 'place-rules-base-create',
      component: PlaceRulesBaseCreateEdit,
      meta: {
        titleI18NKey: 'page-rules.base-rule.title',
        introI18NKey: 'page-rules.base-rule.section-setup.intro',
        breadcrumbs: [memberAreaBreadcrumb],
        actions: [
          {
            name: 'Back',
            icon: 'mdi-undo',
            to: {
              name: 'place-rules-manage',
            },
          },
        ],
      },
    },
    {
      path: 'base/edit/:ruleId',
      name: 'place-rules-base-edit',
      component: PlaceRulesBaseCreateEdit,
      meta: {
        titleI18NKey: 'page-rules.base-rule.title',
        introI18NKey: 'page-rules.base-rule.section-setup.intro',
        breadcrumbs: [memberAreaBreadcrumb],
        actions: [
          {
            name: 'Back',
            icon: 'mdi-undo',
            to: {
              name: 'place-rules-manage',
            },
          },
        ],
      },
    },
    {
      path: 'seasonal/create',
      name: 'place-rules-seasonal-create',
      component: PlaceRulesSeasonalCreateEdit,
      meta: {
        titleI18NKey: 'page-rules.manage.title',
        introI18NKey: 'page-rules.manage.intro',
        breadcrumbs: [memberAreaBreadcrumb],
        actions: [
          {
            name: 'Back',
            icon: 'mdi-undo',
            to: {
              name: 'place-rules-manage',
            },
          },
        ],
      },
    },
    {
      path: 'seasonal/edit/:ruleId',
      name: 'place-rules-seasonal-edit',
      component: PlaceRulesSeasonalCreateEdit,
      meta: {
        titleI18NKey: 'page-rules.manage.title',
        introI18NKey: 'page-rules.manage.intro',
        breadcrumbs: [memberAreaBreadcrumb],
        actions: [
          {
            name: 'Add Seasonal Rule',
            icon: 'mdi-plus',
            to: {
              name: 'place-rules-seasonal-create',
            },
          },
          {
            name: 'Back',
            icon: 'mdi-undo',
            to: {
              name: 'place-rules-manage',
            },
          },
        ],
      },
    },
  ],
}

// push parent onto all children
RulesRoute.children.forEach((child, i) => {
  child.meta.breadcrumbs.push({
    titleI18NKey: (RulesRoute.children[0].meta.titleI18NKey) ? RulesRoute.children[0].meta.titleI18NKey : false,
    text: RulesRoute.children[0].meta.title,
    disabled: false,
    to: {
      name: 'place-rules-manage',
    },
  })
  // push child onto itself
  if (i > 0) {
    child.meta.breadcrumbs.push({
      titleI18NKey: (RulesRoute.children[i].meta.titleI18NKey) ? RulesRoute.children[i].meta.titleI18NKey : false,
      text: RulesRoute.children[i].meta.title,
      disabled: true,
    })
  }
})

const RatesRoute = {
  path: 'rates',
  component: PlaceRates,
  children: [
    {
      path: '',
      name: 'place-rates-manage',
      component: PlaceRatesManage,
      meta: {
        title: 'Rates',
        intro: 'Set Rates for this place.',
        // titleI18NKey
        // introI18NKey
        breadcrumbs: [memberAreaBreadcrumb],
      },
    },
    {
      path: 'create',
      name: 'place-rates-create',
      component: PlaceRatesCreateEdit,
      meta: {
        title: 'Create Rate',
        // titleI18NKey
        // introI18NKey
        breadcrumbs: [memberAreaBreadcrumb],
        actions: [
          {
            name: 'Back',
            icon: 'mdi-undo',
            to: {
              name: 'place-rates-manage',
            },
          },
        ],
      },
    },
    {
      path: 'edit/:rateId',
      name: 'place-rates-edit',
      component: PlaceRatesCreateEdit,
      meta: {
        title: 'Edit Rate',
        // titleI18NKey
        // introI18NKey
        breadcrumbs: [memberAreaBreadcrumb],
        actions: [
          {
            name: 'Add Rate',
            icon: 'mdi-plus',
            to: {
              name: 'place-rates-create',
            },
          },
          {
            name: 'Back',
            icon: 'mdi-undo',
            to: {
              name: 'place-rates-manage',
            },
          },
        ],
      },
    },
    {
      path: 'duplicate/:rateId',
      name: 'place-rates-duplicate',
      component: PlaceRatesCreateEdit,
      meta: {
        title: 'Duplicate Rate',
        intro: 'Duplicate a rate and make any quick adjustments',
        // titleI18NKey
        // introI18NKey
        breadcrumbs: [memberAreaBreadcrumb],
      },
    },
  ],
}

// push parent onto all children
RatesRoute.children.forEach((child, i) => {
  child.meta.breadcrumbs.push({
    text: RatesRoute.children[0].meta.title,
    titleI18NKey: (RatesRoute.children[0].meta.titleI18NKey) ? RatesRoute.children[0].meta.titleI18NKey : false,
    disabled: false,
    to: {
      name: 'place-rates-manage',
    },
  })
  // push child onto itself
  if (i > 0) {
    child.meta.breadcrumbs.push({
      titleI18NKey: (RatesRoute.children[i].meta.titleI18NKey) ? RatesRoute.children[i].meta.titleI18NKey : false,
      text: RatesRoute.children[i].meta.title,
      disabled: true,
    })
  }
})

const ExtrasRoute = {
  path: 'extras',
  component: PlaceExtras,
  children: [
    {
      path: '',
      name: 'place-extras-manage',
      component: PlaceExtrasManage,
      meta: {
        title: 'Extras',
        intro: 'Set add-ons and extras for your guests e.g. dogs, meals, extra beds, towels, guests etc.',
        // titleI18NKey
        // introI18NKey
        breadcrumbs: [memberAreaBreadcrumb],
      },
    },
    {
      path: 'create',
      name: 'place-extras-create',
      component: PlaceExtrasCreateEdit,
      meta: {
        title: 'Create Extra',
        intro: 'Create an add-on for your guest, ranging from dogs to extra guests',
        // titleI18NKey
        // introI18NKey
        breadcrumbs: [memberAreaBreadcrumb],
        actions: [
          {
            name: 'Back',
            icon: 'mdi-undo',
            to: {
              name: 'place-extras-manage',
            },
          },
        ],
      },
    },
    {
      path: 'edit/:extraId',
      name: 'place-extras-edit',
      component: PlaceExtrasCreateEdit,
      meta: {
        title: 'Edit Extra',
        intro: 'Create an add-on for your guest, ranging from dogs to extra guests',
        // titleI18NKey
        // introI18NKey
        breadcrumbs: [memberAreaBreadcrumb],
        actions: [
          {
            name: 'Add Extra',
            icon: 'mdi-plus',
            to: {
              name: 'place-extras-create',
            },
          },
          {
            name: 'Back',
            icon: 'mdi-undo',
            to: {
              name: 'place-extras-manage',
            },
          },
        ],
      },
    },
    {
      path: 'duplicate/:extraId',
      name: 'place-extras-duplicate',
      component: PlaceExtrasCreateEdit,
      meta: {
        title: 'Duplicate Extra',
        intro: 'Duplicate an extra and make any quick adjustments',
        // titleI18NKey
        // introI18NKey
        breadcrumbs: [memberAreaBreadcrumb],
      },
    },
  ],
}

// push parent onto all children
ExtrasRoute.children.forEach((child, i) => {
  child.meta.breadcrumbs.push({
    text: ExtrasRoute.children[0].meta.title,
    titleI18NKey: (ExtrasRoute.children[0].meta.titleI18NKey) ? ExtrasRoute.children[0].meta.titleI18NKey : false,
    disabled: false,
    to: {
      name: 'place-extras-manage',
    },
  })
  // push child onto itself
  if (i > 0) {
    child.meta.breadcrumbs.push({
      titleI18NKey: (ExtrasRoute.children[i].meta.titleI18NKey) ? ExtrasRoute.children[i].meta.titleI18NKey : false,
      text: ExtrasRoute.children[i].meta.title,
      disabled: true,
    })
  }
})

export default [
  {
    path: PlaceRoute.path,
    component: PlaceRoute.component,
    children: [
      {
        path: '',
        name: 'default',
        component: AccommodationRoute.component,
        meta: AccommodationRoute.meta,
      },
      AccommodationRoute,
      RulesRoute,
      RatesRoute,
      ExtrasRoute,
    ],
  },
]
